// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger"
// const { $ } = window

export default {
	init() {
      // gsap.registerPlugin(ScrollTrigger)

		// let $form = $('.block-whitepaper--form')
		// if($form.length) {
		// 	gsap.set($form, { y: 32 })
		// 	gsap.to($form, { opacity: 1, ease:'power1.out', duration: 0.35, delay: 0.5, y:0 })
		// }
		// let $statements = $('.block-whitepaper--statements li')
		// if($statements.length) {
		// 	gsap.set($statements, { opacity: 0, y: 16 })
		// 	gsap.to($statements, { opacity: 1, ease:'power1.out', duration: 0.35, delay: 0.5, y:0, stagger: 0.1 })
		// }
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
